import { language } from './language'
import store from '../store'

export const translate = store.state.i18n.translations[language()] ?? store.state.i18n.translations['br']
